import React from 'react'

import { ReactorContext } from 'reactor/context'

const useReactor = props => {
  return React.useContext(ReactorContext)
}

export default useReactor